import { getImagePath } from '../../../utils/format/valueFormat';

export function loadImage(url: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = () => reject(new Error(`Impossible de charger l'image : ${url}`));
    image.src = getImagePath(url);
  });
}
